import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { RowSelectEventArgs } from '@syncfusion/ej2-react-grids';
import { PolicyView } from '../../../../../../services/CaseManagementService';

/**
 * Hook for handling policy row selection and navigation
 */
export function usePolicyNavigation(company: string) {
  const navigate = useNavigate();

  const handleRowSelected = useCallback(
    (args: RowSelectEventArgs) => {
      const selectedPolicy = args.data as PolicyView;
      if (selectedPolicy?.id) {
        const queryParams = new URLSearchParams({
          company: company,
          policyId: selectedPolicy.id,
        });
        navigate(`/case-management/policies/edit?${queryParams.toString()}`);
      }
    },
    [company, navigate]
  );

  return {
    handleRowSelected,
  };
}
